import { useFetcher } from '@remix-run/react';

const useFormState = () => {
  const fetcher = useFetcher();
  const data = fetcher.data;
  const isSubmitting = fetcher.state === 'submitting';
  const isLoading = fetcher.state === 'loading';
  const isSuccessful = data?.toast?.status === 'success';
  const isFailed = data?.toast?.status === 'error';

  return {
    fetcher,
    data,
    isSubmitting,
    isLoading,
    isSuccessful,
    isFailed,
  };
};

export default useFormState;
